import React from 'react';
import { systemCode, xs_isMobile, xs_languageCode } from '../..';
import { getCheckSystemBetsPage } from '../../data/utils/getCheckSystemBetsPage';
import { getConfiguration } from '../../data/utils/configuration';
import { getCurrencySymbol } from '../../data/utils/getCurrencySymbol';
import { getPrintableAmount } from '../../data/utils/getPrintableAmount';
import { getUkCombinationName } from '../../data/utils/getUkCombinationName';
import { isUKCombinationMaskEnabled } from '../../data/utils/isUKCombinationMaskEnabled';
import { getLabel } from '../../data/labels';
import { getEnv } from '../env';

function TupleInfo(props) {
    const conf = getConfiguration();
    const currency = getCurrencySymbol(conf.cs.ct);
    const ticketId = props.ticketId;
    const isMobile = xs_isMobile;

    function openCheckSystemBets(event) {
        if (props.openCheckSystemBets) {
            event.preventDefault();
            event.stopPropagation();
            props.openCheckSystemBets();
            return;
        }

        const width = isMobile ? 400 : 1400;
        const height = isMobile ? 800 : 900;
        event.preventDefault();
        const checkSystemBets = getCheckSystemBetsPage(isMobile);
        const appRoot = (getEnv('REACT_APP_ROOT') || '');
        const appPathname = appRoot.substring(appRoot.indexOf("/") + 1) || (isMobile ? 'xsport_mobile' : 'xsport_desktop');
        const publicUrl = window.XSPORT_PUBLIC_URL.replace(appPathname,'xsport_desktop');
        const url = `${publicUrl}${checkSystemBets}?ticket=${ticketId}&system_code=${systemCode}&language=${xs_languageCode}`;
        window.open(url, '', `width=${width},height=${height}`);
    }

    return (
        <>
            <div id="check-system-bets" className="d-flex margine-su-giu | mb_9_1">
                <a href="" onClick={openCheckSystemBets} className="bold | mb_9_1_1">{getLabel('check_system_bets.check_system')}</a>
            </div>
            {props.tuples.map((t, i) => {
                return (
                    <React.Fragment key={i}>
                        <div className="d-flex flex-column text-small grey | mb_9_2">
                            <div className="d-flex justify-content-space-between | mb_9_2_1">
                                <div className="d-flex margine-su-giu | mb_9_2_1_1">
                                    <span className="mb_9_2_1_1_1">{getLabel('mybets.sistema')}:&nbsp;</span>
                                    <span className="bold | mb_9_2_1_1_2">{isUKCombinationMaskEnabled()? getUkCombinationName(t.npla, t.isAccumulator) : t.desc}</span>
                                </div>
                                <div className="d-flex margine-su-giu | mb_9_2_1_1">
                                    <span className="mb_9_2_1_1_1">{getLabel('mybets.combinazioni')}:&nbsp;</span>
                                    <span className="bold | mb_9_2_1_1_2">{t.combinations}</span>
                                </div>
                            </div>
                            <div className="d-flex justify-content-space-between | mb_9_2_1">
                                <div className="d-flex margine-su-giu | mb_9_2_1_1">
                                    <span className="mb_9_2_1_1_1">{getLabel('mybets.importo')}:&nbsp;</span>
                                    <span className="bold | mb_9_2_1_1_2">{props.hideAmounts ?  '' : <> {getPrintableAmount(t.amount, conf.cs.m, conf.cs.nd)} {currency} </> }</span>
                                </div>
                                <div className="d-flex margine-su-giu | mb_9_2_1_1">
                                    <span className="mb_9_2_1_1_1">{getLabel('mybets.vincitaminima')}:&nbsp;</span>
                                    <span className="bold | mb_9_2_1_1_2">{props.hideAmounts ? '' : <>{getPrintableAmount(t.minWinnings, conf.cs.m, conf.cs.nd)} {currency}</>}</span>
                                </div>
                                <div className="d-flex margine-su-giu | mb_9_2_1_1">
                                    <span className="mb_9_2_1_1_1">{getLabel('mybets.vincitamassima')}:&nbsp;</span>
                                    <span className="bold | mb_9_2_1_1_2">{props.hideAmounts ? '' : <>{getPrintableAmount(t.maxWinnings, conf.cs.m, conf.cs.nd)} {currency}</>}</span>
                                </div>
                            </div>
                        </div>
                        {i < (props.tuples.length - 1) &&
                            <hr className="mb_4" />
                        }
                    </React.Fragment>
                );
            })}
        </>
    );
}

export default TupleInfo;